import Styled from 'styled-components'


export const ContainerDate = Styled.div`

.rdrSelected, .rdrInRange{
    background-color: ${props => !props.noDate ? '#FFF' : props.theme.primary };
    border-radius: 50%;
}

.rdrCalendarWrapper:not(.rdrDateRangeWrapper) .rdrDayHovered .rdrDayNumber:after{
    border: none;
}

.rdrMonthName {
    text-align: center;
    font-weight: 400;
    color: #000000;
    text-transform: capitalize;
}


.rdrDateDisplayWrapper {
    background-color: transparent !important;
}

.rdrDayWeekend:not(.rdrDayDisabled) .rdrDayNumber span {
    color: #1d2429;
}


.rdrDayDisabled, .rdrDayPassive {
    background-color: #FFF;
}

.rdrWeekDay {
    text-transform: capitalize;
}
//
// .rdrInRange {
//     background-color: ${props => !props.noDate ? '#D9D9D9' : '#FFF' };
// }

.rdrSelected, .rdrInRange, .rdrStartEdge, .rdrEndEdge {
    top: 3px;
    bottom: 3px;
    left: 7px;
    right: 7px;
}

.rdrDayToday .rdrDayNumber span:after {
    background: ${props => props.theme.primary};;
}

.rdrMonthAndYearPickers {
    text-transform: capitalize;
    font-size: 14px;
}


.gMsJiF .rdrSelected, .gMsJiF .rdrInRange, .gMsJiF .rdrStartEdge, .gMsJiF .rdrEndEdge {
    color: ${props => props.theme.primary};;
}

.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,  {
    color: ${props => !props.noDate ? '#333' : '#FFF' };
}

.rdrDayDisabled .rdrDayNumber span {
     color: #D9D9D9 !important;
}

.rdrDay:not(.rdrDayPassive):not(.rdrDayDisabled) .rdrSelected ~ .rdrDayNumber span {
    color: #D9D9D9 !important;
}

.rdrDayDisabled, .rdrDayPassive {
    background-color: #FFF !important;
}

.rdrDayPassive > .rdrDayNumber * {
 // color: transparent !important;
  visibility: hidden;
}

.rdrEndEdge {
     border-radius: 50%;
}

.rdrDayEndOfMonth .rdrInRange, .rdrDayEndOfMonth .rdrStartEdge, .rdrDayEndOfWeek .rdrInRange, .rdrDayEndOfWeek .rdrStartEdge {
    border-radius: 50%;
}

.rdrDayStartOfMonth .rdrInRange, .rdrDayStartOfMonth .rdrEndEdge, .rdrDayStartOfWeek .rdrInRange, .rdrDayStartOfWeek .rdrEndEdge {
     border-radius: 50%;
}

.rdrStartEdge {
    border-radius: 50%;
}

.rdrDayEndPreview {
     border-radius: 50%;
}

.rdrDayStartPreview {
     border-radius: 50%;
}
`
